// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum SystemComponentOutageState {
  Unknown = "UNKNOWN",
  Active = "ACTIVE",
  Planned = "PLANNED",
  Passed = "PASSED",
}
export default SystemComponentOutageState;
